import styled from 'styled-components'

import LoginLink from '../../../global/LoginLink'

export const LoginButtonLink = styled(LoginLink)`
  color: ${({ theme }) => theme.colors.brand.white};
  padding: 17px 16px;
  width: 100%;
  margin: 0 auto;
  border-radius: 5px;
  line-height: 16px;
  min-height: 50px;
  max-height: 50px;
  background-color: ${({ theme }) => theme.colors.component.backgroundDarkBlue};
  font-family: ${({ theme }) => theme.fontFamilies.robotoCondensed};
  font-size: 16px;
  font-weight: 700;
  text-transform: none;
  transition:
    color 0.15s ease-in-out,
    background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;

  &:focus {
    outline: none;
  }
  &:hover {
    background-color: #0b2648cc;
  }
`
